import { getAPIUrl } from '../helpers/App';

export const APIgetTaxonomies = ({ share, ...params } = {}) => {
  const path = share ? '/shares/taxonomies' : '/taxonomies';
  return window.axios.get(getAPIUrl(path), { params })
    .then(response => (response));
};

export const APIcreateTaxonomy = taxonomy => (
  window.axios.post(getAPIUrl('/taxonomies'), { taxonomy })
    .then(response => (response))
);

export const APIgetTaxonomy = taxonomyId => (
  window.axios.get(getAPIUrl(`/taxonomies/${taxonomyId}`))
    .then(response => (response))
);

export const APIupdateTaxonomy = taxonomy => (
  window.axios.patch(getAPIUrl(`/taxonomies/${taxonomy.id}`), { taxonomy })
    .then(response => (response))
);

export const APIdeleteTaxonomy = taxonomyId => (
  window.axios.delete(getAPIUrl(`/taxonomies/${taxonomyId}`))
    .then(response => (response))
);

export const APIgetTerms = (taxonomyId, params) => (
  window.axios.get(getAPIUrl(`/taxonomies/${taxonomyId}/terms`), { params })
    .then(response => (response))
);

export const APIcreateTerm = (taxonomyId, params) => (
  window.axios.post(getAPIUrl(`/taxonomies/${taxonomyId}/terms`), { ...params })
    .then(response => (response))
);

export const APIimportTerms = (taxonomyId, content, params = {}) => (
  window.axios.post(getAPIUrl(`/taxonomies/${taxonomyId}/import`), { content, ...params })
    .then(response => (response))
);

export const APIupdateTerm = term => (
  window.axios.patch(getAPIUrl(`/terms/${term.id}`), { term })
    .then(response => (response))
);

export const APImoveTerm = (currentTaxonomyId, targetTaxonomyId, terms) => (
  window.axios.patch(getAPIUrl('/terms/move'), {
    currentTaxonomyId,
    targetTaxonomyId,
    terms,
  }).then(response => (response))
);

export const APIblockTerm = (params) => (
  window.axios.patch(getAPIUrl('/terms/block'), {
    ...params,
  }).then(response => (response))
);

export const APIdeleteTerm = termId => (
  window.axios.delete(getAPIUrl(`/terms/${termId}`))
    .then(response => (response))
);

export const APIupdateCustomCategoriesOrder = (taxonomies) => (
  window.axios.patch(getAPIUrl('/taxonomies/order'), { taxonomies })
    .then(response => (response))
);

export const APIgetMetadataGroups = ({ share, ...params } = {}) => {
  const path = share ? '/shares/metadata-groups' : '/metadata-groups';
  return window.axios.get(getAPIUrl(path), { params })
    .then(response => (response));
};

export const APIcreateMetadataGroup = metadataGroup => (
  window.axios.post(getAPIUrl('/metadata-groups'), { metadata_group: metadataGroup })
    .then(response => (response))
);

export const APIupdateMetadataGroup = metadataGroup => (
  window.axios.patch(getAPIUrl(`/metadata-groups/${metadataGroup.id}`), { metadata_group: metadataGroup })
    .then(response => (response))
);

export const APIresetDefaultMetadataGroup = () => (
  window.axios.post(getAPIUrl(`/metadata-groups/reset-default`))
    .then(response => (response))
);

export const APIdeleteMetadataGroup = metadataGroupId => (
  window.axios.delete(getAPIUrl(`/metadata-groups/${metadataGroupId}`))
    .then(response => (response))
);

export const APIupdateMetadataGroupOrder = (metadataGroupId, params) => (
  window.axios.patch(getAPIUrl(`/metadata-groups/${metadataGroupId}/order`), { ...params })
    .then(response => (response))
);

export const APIgetCustomFields = ({ share, ...params } = {}) => {
  const path = share ? '/shares/custom-fields' : '/custom-fields';
  return window.axios.get(getAPIUrl(path), { params })
    .then(response => (response));
};

export const APIcreateCustomField = customField => (
  window.axios.post(getAPIUrl('/custom-fields'), { custom_field: customField })
    .then(response => (response))
);

export const APIgetCustomField = customFieldId => (
  window.axios.get(getAPIUrl(`/custom-fields/${customFieldId}`))
    .then(response => (response))
);

export const APIupdateCustomField = customField => (
  window.axios.patch(getAPIUrl(`/custom-fields/${customField.id}`), { custom_field: customField })
    .then(response => (response))
);

export const APIdeleteCustomField = customFieldId => (
  window.axios.delete(getAPIUrl(`/custom-fields/${customFieldId}`))
    .then(response => (response))
);

export const APIupdateCustomFieldsOrder = customFields => (
  window.axios.patch(getAPIUrl('/custom-fields/order'), { custom_fields: customFields })
    .then(response => (response))
);
